import React, { useEffect } from "react";
import CustomCheckbox from "./CustomCheckbox";
import { SET_TRADE_24_HOURS, SET_TRADE_24_HOURS_RENT } from "../../../../actions/create-bot-type";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { isPro } from "../../../../utils/SubUtils";
import { eligible24dHours } from "../../../../utils/Utils";
import LeftRightForm from "./LeftRightForm";

const TwentyFourHoursTrading = (props)=>{
    const {rent} = props
    const newBot = useSelector((state) => state.createBot.newBot);
    const rentBot = useSelector((state) => state.createBot.rentBot);
    const {t} = useTranslation()
    const selectedExchange = rent ? rentBot.exchange : newBot.exchange;
    const subscription = useSelector((state) => state.auth.user.user_subscription) || {};
    const tradingHour247 = parseInt(rent?rentBot.tradingHour247:newBot.tradingHour247)?1:0;
    const dispatch = useDispatch()
    const set24HoursTrading = (val) => {
        dispatch({
          type: rent?SET_TRADE_24_HOURS_RENT:SET_TRADE_24_HOURS,
          payload: val?1:0,
        });
    };
    useEffect(() => {
      if(selectedExchange.id === 6){
        set24HoursTrading(1);
        return;
      }
    },[]);
    return(<>
        {(isPro(subscription) && eligible24dHours(selectedExchange) && selectedExchange.id != 6) && 
        
            <LeftRightForm 
            left={<></>}
            right={ <CustomCheckbox 
                val={tradingHour247} 
                checked={tradingHour247} 
                callback={set24HoursTrading}
                label={t("Enable 24 Hour")}
                id={'trade-24-hours'}
                >
                </CustomCheckbox>}
            >
            </LeftRightForm>
        
           }
    </>)
}

export default TwentyFourHoursTrading;